/**
 * The wall's scroll container, for what the masonry renders around its
 * cards. A look-ahead `IntersectionObserver` needs it as its `root`: with the
 * implicit root (the browser viewport) the `rootMargin` never reaches past
 * the scroller's clipping edge.
 */
import { createContext, useContext, type RefObject } from "react";

export const WallScrollRootContext =
  createContext<RefObject<HTMLElement | null> | null>(null);

/** The wall's scroller once mounted; null outside the wall. */
export function useWallScrollRoot(): RefObject<HTMLElement | null> | null {
  return useContext(WallScrollRootContext);
}
